import styled from 'styled-components';

const LayoutWrapper = styled.div`
  flex-grow: 1;
  height: 100%;
`;

export default LayoutWrapper;
